import { useJobSearchByQueryQuery } from '@/graphql/generated';
import { useLoginStates } from '@/hooks';

import { DS, ITEMS_PER_PAGE } from '../constants';
import { useSearchQuery } from '../contexts/search-query-context';
import { isFullRemoteOnlyByQueryParam } from '../helpers';
import { useRedirectLegacyURL } from './use-redirect-legacy-url';

type Options = {
  isEmptyStateSearch?: boolean;
};

export const useSearch = ({ isEmptyStateSearch = false }: Options = {}) => {
  const { isLoggedOut } = useLoginStates();
  const { searchQuery, page, sort, isUserCityLoading } = useSearchQuery();
  const { isLegacyURL } = useRedirectLegacyURL();

  const skip = isUserCityLoading || isLegacyURL;
  const isFullRemoteOnly = isFullRemoteOnlyByQueryParam(searchQuery.filter?.remoteOption?.id);
  const query = isEmptyStateSearch || isFullRemoteOnly ? { ...searchQuery, location: undefined } : searchQuery;

  const result = useJobSearchByQueryQuery({
    variables: {
      query,
      consumer: isLoggedOut ? DS.CONSUMER.LO : DS.CONSUMER.LI,
      limit: ITEMS_PER_PAGE,
      offset: ITEMS_PER_PAGE * (page - 1),
      sort,
      trackRecent: !isEmptyStateSearch,
    },
    errorPolicy: 'all',
    skip,
  });

  return skip ? { ...result, loading: true } : result;
};
